import { Strategy, StrategyGroup } from "features/trading/accounts";
import { useListStrategiesQuery, useListStrategyGroupsQuery } from "features/trading/accounts";
import { useState } from "react";
import { GridModel } from "features/api";
import SelectionModal from "./SelectionModal";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

interface StockSelectionModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (strategy: Strategy) => void;
}

const PAGE_SIZE = 10;

const StockSelectionModal = ({ open, onClose, onSelect }: StockSelectionModalProps) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedGroup, setSelectedGroup] = useState<number | "">("");

  const { data: strategiesData, isLoading: isStrategiesLoading, isFetching: isStrategiesFetching } = useListStrategiesQuery({
    pagination: {
      page: page - 1, // Convert to 0-based index
      pageSize: PAGE_SIZE
    },
    filters: {
      strategy_group: selectedGroup || undefined
    },
    gridFilters: searchQuery ? {
      quickFilterValues: searchQuery
    } : undefined
  } as GridModel);

  const { data: groupsData, isLoading: isGroupsLoading } = useListStrategyGroupsQuery({});

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
    setPage(1); // Reset to first page when searching
  };

  const handleGroupChange = (event: any) => {
    setSelectedGroup(event.target.value);
    setPage(1); // Reset to first page when changing group
  };

  return (
    <SelectionModal<Strategy>
      open={open}
      onClose={onClose}
      onSelect={onSelect}
      title="Select Stock"
      searchPlaceholder="Search by stock name or symbol..."
      items={strategiesData?.results}
      isLoading={isStrategiesLoading || isGroupsLoading}
      isFetching={isStrategiesFetching}
      totalCount={strategiesData?.count || 0}
      pageSize={PAGE_SIZE}
      currentPage={page}
      onPageChange={handlePageChange}
      onSearchChange={handleSearchChange}
      renderItem={(strategy) => ({
        primary: strategy.name,
        secondary: groupsData?.results.find(group => group.id === strategy.strategy_group)?.name || 'None'
      })}
      additionalFilters={
        <FormControl fullWidth>
          <InputLabel>Strategy Group</InputLabel>
          <Select
            value={selectedGroup}
            label="Strategy Group"
            onChange={handleGroupChange}
            disabled={isGroupsLoading}
          >
            <MenuItem value="">All Groups</MenuItem>
            {groupsData?.results.map((group: StrategyGroup) => (
              <MenuItem key={group.id} value={group.id}>
                {group.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      }
    />
  );
};

export default StockSelectionModal;
